import ExportsView from '@/exports/ExportsView.vue'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerRoute} from '@/router'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'

export const EXPORTS = {componentName: 'Exports', component: ExportsView, meta: {requiresOrg: true}}
const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()

const icon = 'i-ph-export-fill'
const label = 'Eksporterte rapporter'
const route = EXPORTS

registerNavigationCommand({
    route,
    label,
    icon,
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: label,
    key: 'exports',
    icon,
    target: route
})

registerRoute(route)
buildSimpleCrumb(route, label, icon, true)